import { Directive, Input, inject } from "@angular/core";
import {NgControl} from "@angular/forms";
import {MAT_DATE_FORMATS, MatDateFormats} from "@angular/material/core";
import {CustomDateFormat, DateParse} from "../models/custom-date-format";

@Directive({
  selector: '[datePickerFormat]',
  standalone: true
})
export class DatePickerFormatDirective {
  matDateFormat = inject<CustomDateFormat | MatDateFormats>(MAT_DATE_FORMATS);
  private ngControl = inject(NgControl, { optional: true });

  @Input() public configDateParse: DateParse;

  @Input("datePickerFormat")
  set datePickerFormat(format: string) {
    const nextParse: DateParse = this.configDateParse ?? { dateInput: format };
    const dateFormats = this.matDateFormat as CustomDateFormat & MatDateFormats;

    if (typeof dateFormats?.updateDateFormat === 'function') {
      dateFormats.updateDateFormat(nextParse);
    } else if (dateFormats?.parse) {
      dateFormats.parse = {
        ...dateFormats.parse,
        ...nextParse
      };
    }

    if (this.ngControl) {
      const value = this.ngControl.control?.value ?? this.ngControl.value;
      this.ngControl.valueAccessor?.writeValue(value);
    } else {
      return;
    }
  }
}
